import styled from "styled-components";

import { TActionIconStyleProps } from "./types";

export const ActionIconButton = styled.span<TActionIconStyleProps>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;